import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';

import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionarPartes from './OperacoesEmLoteSelecionarPartes';
import PainelProcessosOperacoesEmLotePartes from './PainelProcessosOperacoesEmLotePartes';

class IntimarPautaLote extends ReactComponent {
    dialogListagemOpen = false;
    dialogConfirmacaoOpen = false;
    carregando = false;
    errosValidacaoFechamento = [];
    openDialog = false;
    enviarCertidao = true;
    codigoOTP = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            confirmarIntimar: true,
            sessao: computed,
            removerPartesDuplicadas: true,
            partesIntimaveis: true,
            render: true,
            isStringPreenchida: true,
            desabilitarConfirmar: true,
            renderDialogConfirmacao: true,
            renderConteudoConfirmacao: true,

            handleCloseDialogConfirmacao: action,
            partesSelecionaveis: computed,
            dialogListagemOpen: observable,
            dialogConfirmacaoOpen: observable,
            carregando: observable,
            errosValidacaoFechamento: observable,
            openDialog: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleConfirmarIntimar: action,
            processosIntimacao: computed,
            processoIntimacaoDto: computed,
            limparProcessoPesquisa: action,
            processos: computed,
            existeProcessoParaIntimacao: computed,
            quantidadeProcessosParaIntimacao: computed,
            quantidadePartesParaIntimacao: computed,
            mensagemLoteSemProcessos: computed,
            handleClickConfirmar: action,
            renderConteudo: computed,
            processosSelecionaveis: computed,
            enviarCertidao: observable,
            handleChangeEnviarCertidao: action,
            codigoOTP: observable,
            mensagemConfirmacao: computed,
            handleChangeCodigoOTP: action,
            atualizarDataEnvioDomicilioEletronico: action
        });
    }

    handleClickIcone = () => {
        this.dialogListagemOpen = true;
        this.limparProcessoPesquisa();
    };

    handleCloseDialog = () => {
        this.dialogListagemOpen = false;
    };

    handleCloseDialogConfirmacao = () => {
        this.dialogConfirmacaoOpen = false;
    };

    handleConfirmarIntimar = async () => {
        const resultado = await this.pautaJulgamentoStore.processarLote({
            titulo: 'Intimar partes',
            indeterminate: true,
            qtdTotalProcessos: this.quantidadePartesParaIntimacao,
            lotesProcessos: [this.processoIntimacaoDto],
            funcaoOperacao: this.confirmarIntimar
        });
        this.handleCloseDialogConfirmacao();
        this.atualizarDataEnvioDomicilioEletronico(resultado);
    };

    atualizarDataEnvioDomicilioEletronico(resultado) {
        if (Array.isArray(resultado)) {
            for (const elemento of resultado) {
                if (elemento.erro === true) {
                    continue;
                }
                const numero = elemento.numeroProcesso;
                const parte = elemento.parte;
                const partesProcesso = this.pautaJulgamentoStore.mapaProcessosPartesPautaSelecionada[numero];

                for (const p of partesProcesso.partes) {
                    if (p.cpfCnpj === parte.cpfCnpj) {
                        runInAction(
                            () =>
                                (p.intimacaDomicilioEletronico = {
                                    dataIntimacao: parte.intimacaDomicilioEletronico?.dataIntimacao
                                })
                        );
                    }
                }
            }
        }
    }

    confirmarIntimar = async () => {
        const resultado = await this.sessaoService.confirmarIntimarPauta(
            this.pautaJulgamentoStore.idPautaSelecionada,
            {
                otp: this.codigoOTP,
                processosIntimacao: this.processoIntimacaoDto
            },
            this.enviarCertidao
        );
        this.pautaJulgamentoStore.atualizarProcessamentoLote(resultado);
        return resultado;
    };

    get processoIntimacaoDto() {
        return this.store.checkedOperacoesEmLotePartesToList();
    }

    get processosIntimacao() {
        return this.processosSelecionados.filter((registro) =>
            this.store.isCheckedOperacoesEmLotePartes(registro.processo.numeroCompleto)
        );
    }

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processos() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter((registro) =>
            this.filtrarProcessoPeloNumero(registro)
        );
    }

    get existeProcessoParaIntimacao() {
        return this.quantidadeProcessosParaIntimacao > 0;
    }

    get quantidadeProcessosParaIntimacao() {
        return this.store.quantidadeProcessosCheckedOperacoesEmLotePartes();
    }

    get quantidadePartesParaIntimacao() {
        return this.store.quantidadePartesCheckedOperacoesEmLotePartes();
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => this.partesIntimaveis(registro).length > 0);
    }

    get partesSelecionaveis() {
        const partesSelecionaisProcessos = new Map();

        if (this.pautaJulgamentoStore.mapaProcessosPartesPautaSelecionada) {
            for (const numero in this.pautaJulgamentoStore.mapaProcessosPartesPautaSelecionada) {
                const partesProcesso = this.pautaJulgamentoStore.mapaProcessosPartesPautaSelecionada[numero];

                if (partesProcesso && partesProcesso.partes) {
                    const partesComDomicilio = partesProcesso.partes.filter((parte) => parte.codigoDomicilioEletronico);

                    if (partesComDomicilio.length > 0) {
                        partesSelecionaisProcessos.set(numero, this.removerPartesDuplicadas(partesComDomicilio));
                    }
                }
            }
        }
        return partesSelecionaisProcessos;
    }

    removerPartesDuplicadas(partes) {
        const partesNaoDuplicadas = [];

        for (const parte of partes) {
            if (
                partesNaoDuplicadas.every((parteNaoDuplicada) => {
                    return !(parteNaoDuplicada.cpfCnpj
                        ? parteNaoDuplicada.cpfCnpj === parte.cpfCnpj
                        : parteNaoDuplicada.nome === parte.nome);
                })
            ) {
                partesNaoDuplicadas.push(parte);
            }
        }
        return partesNaoDuplicadas;
    }

    partesIntimaveis(registro) {
        if (this.store.mapaProcessosPartes && registro.confirmadaInclusaoPauta) {
            const partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];

            if (partesProcesso?.partes) {
                return this.removerPartesDuplicadas(
                    partesProcesso.partes.filter(
                        (parte) => parte.codigoDomicilioEletronico && !parte.intimacaDomicilioEletronico?.dataIntimacao
                    )
                );
            }
        }
        return [];
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos a intimar' + this.complementoMensagemFiltrando;
    }

    handleClickConfirmar = () => {
        this.dialogConfirmacaoOpen = true;
    };

    handleChangeEnviarCertidao = () => {
        this.enviarCertidao = !this.enviarCertidao;
    };

    handleChangeCodigoOTP = (event) => {
        this.codigoOTP = event.target.value;
        this.codigoOTP = this.codigoOTP.toString();
    };

    render() {
        return (
            this.pautaJulgamentoStore.origemPautaSelecionadaPJe &&
            this.isComponenteHabilitado('IntimarDomicilioEletronico') && (
                <>
                    <div
                        className="corBotao"
                        style={{ marginRight: '10px', paddingLeft: '5px' }}
                    >
                        <Tooltip
                            placement="top-start"
                            title={'Intimar partes dos processos em pauta'}
                        >
                            <FontAwesomeIcon
                                style={{
                                    cursor: 'pointer',
                                    width: '18px',
                                    height: '18px',
                                    marginRight: '5px',
                                    paddingLeft: '5px'
                                }}
                                icon={faEnvelope}
                                id="domicilioEletronico"
                                onClick={this.handleClickIcone}
                            />
                        </Tooltip>
                    </div>
                    {!!this.dialogListagemOpen && (
                        <Dialog
                            fullWidth
                            open
                            maxWidth="xl"
                            onClose={this.handleCloseDialog}
                            PaperProps={{ style: { height: '100%' } }}
                        >
                            <DialogTitle>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            flexGrow: 1
                                        }}
                                    >
                                        <h4 style={{ margin: '0px' }}>Intimar partes</h4>
                                        <div style={{ margin: '0px 10px' }}>
                                            <NumeroProcesso
                                                dense
                                                callbackOnChange={this.callbackNumeroProcesso}
                                                clickLimpar={this.limparProcessoPesquisa}
                                                tooltip="Número do processo a ser pesquisado na listagem"
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    margin: '10px',
                                                    paddingTop: '5px'
                                                }}
                                            >
                                                <PainelFiltros />
                                            </div>
                                            <FiltroRapido id="filtroRapidoIntimarPartesPautaLote" />
                                        </div>
                                    </div>
                                </div>
                            </DialogTitle>
                            {this.renderConteudo}
                        </Dialog>
                    )}
                    {this.renderDialogConfirmacao()}
                </>
            )
        );
    }

    get renderConteudo() {
        return this.sessaoStore.carregandoProcessos || this.store.carregandoPartes ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    disableShrink
                    style={{ margin: '20px' }}
                />
                <Typography
                    style={{ margin: '25px 10px' }}
                    variant="h6"
                >
                    Carregando processos e partes...
                </Typography>
            </div>
        ) : (
            <>
                <OperacoesEmLoteSelecionarPartes
                    partesSelecionaveis={this.partesSelecionaveis}
                    processos={this.processos}
                    processosSelecionaveis={this.processosSelecionaveis}
                />
                <PainelProcessosOperacoesEmLotePartes
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    partesSelecionaveis={this.partesSelecionaveis}
                    processos={this.processosSelecionaveis}
                />
                <DialogActions>
                    <Button
                        color="secondary"
                        endIcon={<CancelIcon />}
                        onClick={this.handleCloseDialog}
                        variant="outlined"
                    >
                        Fechar
                    </Button>
                    <Button
                        color="primary"
                        disabled={!this.existeProcessoParaIntimacao}
                        endIcon={<CheckIcon />}
                        onClick={this.handleClickConfirmar}
                        variant="outlined"
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </>
        );
    }

    isStringPreenchida(string) {
        return string && (string + '').trim() !== '';
    }

    get desabilitarConfirmar() {
        return this.enviarCertidao && !this.isStringPreenchida(this.codigoOTP);
    }

    renderDialogConfirmacao() {
        return (
            this.dialogConfirmacaoOpen && (
                <Dialog
                    fullWidth
                    open
                    maxWidth="md"
                >
                    <DialogTitle>Intimar partes</DialogTitle>
                    <DialogContent>
                        {this.carregando ? (
                            <CircularProgress
                                disableShrink={true}
                                style={{ margin: '10px' }}
                            />
                        ) : (
                            this.renderConteudoConfirmacao()
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.handleCloseDialogConfirmacao}
                            variant="outlined"
                        >
                            Fechar
                        </Button>
                        <Button
                            color="primary"
                            disabled={this.desabilitarConfirmar}
                            endIcon={<CheckIcon />}
                            onClick={this.handleConfirmarIntimar}
                            variant="outlined"
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    get mensagemConfirmacao() {
        return this.quantidadePartesParaIntimacao === 1
            ? 'Será intimada 1 parte em 1 processo.'
            : 'Serão intimadas ' +
                  this.quantidadePartesParaIntimacao +
                  ' partes em ' +
                  // eslint-disable-next-line sonarjs/no-nested-conditional
                  (this.quantidadeProcessosParaIntimacao === 1
                      ? '1 processo.'
                      : this.quantidadeProcessosParaIntimacao + ' processos.');
    }

    renderConteudoConfirmacao() {
        return (
            <>
                <div style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                    <div style={{ marginBottom: '4px' }}>
                        <Typography display="inline">
                            <b>{this.mensagemConfirmacao}</b>
                        </Typography>
                    </div>
                </div>
                <>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '3px 0px',
                            marginLeft: '60px'
                        }}
                    >
                        <Typography
                            style={{
                                marginRight: '15px',
                                whiteSpace: 'nowrap',
                                textAlign: 'left',
                                width: '100px'
                            }}
                            color="primary"
                            variant="subtitle1"
                        >
                            <b>Gerar certidão</b>
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    checked={this.enviarCertidao}
                                    onChange={this.handleChangeEnviarCertidao}
                                    style={{ padding: '4px' }}
                                />
                                <IconButton
                                    aria-label="Gerar certidão"
                                    color="inherit"
                                    size="large"
                                    style={{ width: '50px' }}
                                >
                                    <Tooltip
                                        title={
                                            this.enviarCertidao
                                                ? 'Incluir certidão de intimação para os processos selecionados.'
                                                : ' NÃO haverá a anexação de certidão de intimação nos processos selecionados'
                                        }
                                    >
                                        <InfoIcon style={{ color: '#01579b' }} />
                                    </Tooltip>
                                </IconButton>
                            </div>
                        </div>
                    </div>
                    {!!this.enviarCertidao && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '3px 0px',
                                marginLeft: '70px'
                            }}
                        >
                            <Typography
                                style={{
                                    marginRight: '15px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'right',
                                    width: '95px'
                                }}
                                color="primary"
                                variant="subtitle1"
                            >
                                <b>{'Código OTP'}</b>
                            </Typography>
                            <div style={{ display: 'flex', alignItems: 'center', width: '40%' }}>
                                <div style={{ width: '100%' }}>
                                    <TextField
                                        fullWidth={true}
                                        id={'idCodigoOTP'}
                                        margin={'dense'}
                                        onChange={this.handleChangeCodigoOTP}
                                        size={'small'}
                                        type="number"
                                        variant="outlined"
                                    />
                                </div>
                                <div>
                                    <IconButton
                                        aria-label="Codigo OTP"
                                        color="inherit"
                                        size="large"
                                        style={{ width: '50px' }}
                                    >
                                        <Tooltip
                                            title={
                                                'Código OTP gerado pelo aplicativo JTe. Será utilizado para assinatura das certidões de inclusão em pauta geradas nos processos que forem publicados.'
                                            }
                                        >
                                            <InfoIcon style={{ color: '#01579b' }} />
                                        </Tooltip>
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    )}
                </>{' '}
            </>
        );
    }
}

export default inject('stores')(observer(IntimarPautaLote));
